import { DecoratorFactory } from "./DecoratorFactory";
const createDecorator = (contentState, highlight, text) => {
    console.warn('createDecorator is deprecated.  Use DecoratorFactory().create');
    text = text || contentState.getPlainText();
    const decoratorFactory = new DecoratorFactory();
    return decoratorFactory.create(contentState, highlight, text);
};
export { createDecorator };
